import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { Mail, Phone, MapPin, Clock, Star } from "lucide-react";
import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/SiteFooter";

/* ------------------------------------------------------------------ *
 *  EDIT THESE when you have your social links (leave "" to disable).  *
 * ------------------------------------------------------------------ */
const CONTACT = {
  email: "support@nlcsshop.co.uk",
  phone: "+441252950574",
  phoneDisplay: "+44 1252 950574",
  whatsapp: "447879120666", // digits only, no + or spaces
};

const REVIEW_URL = "https://g.page/r/CSNcEWjb0a9aEBI/review";

const SOCIALS = {
  whatsapp: `https://wa.me/${CONTACT.whatsapp}`,
  facebook: "https://www.facebook.com/share/1DFau4h9r1/",
  instagram: "https://instagram.com/nlcs.co.uk",
  tiktok: "https://tiktok.com/@nlcs.co.uk",
  x: "https://x.com/NLCS_UK",
  youtube: "https://www.youtube.com/@nlcs-offcial",
};

const Icon = ({ children }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="h-6 w-6" aria-hidden="true">
    {children}
  </svg>
);

const brandIcons = {
  whatsapp: (
    <Icon>
      <path d="M.057 24l1.687-6.163a11.867 11.867 0 01-1.587-5.945C.16 5.335 5.495 0 12.05 0a11.82 11.82 0 018.413 3.488 11.82 11.82 0 013.48 8.414c-.003 6.557-5.338 11.892-11.893 11.892a11.9 11.9 0 01-5.688-1.448L.057 24zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884a9.86 9.86 0 001.599 5.393l-.999 3.648 3.9-1.44zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.767.967-.94 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.52.149-.174.198-.298.297-.497.099-.198.05-.371-.025-.52-.074-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413z" />
    </Icon>
  ),
  facebook: (
    <Icon>
      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
    </Icon>
  ),
  instagram: (
    <Icon>
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
    </Icon>
  ),
  tiktok: (
    <Icon>
      <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" />
    </Icon>
  ),
  x: (
    <Icon>
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </Icon>
  ),
  youtube: (
    <Icon>
      <path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
    </Icon>
  ),
};

const socialMeta = [
  { key: "whatsapp", label: "WhatsApp", color: "#25D366" },
  { key: "facebook", label: "Facebook", color: "#1877F2" },
  { key: "instagram", label: "Instagram", color: "#E4405F" },
  { key: "tiktok", label: "TikTok", color: "#010101" },
  { key: "x", label: "X", color: "#000000" },
  { key: "youtube", label: "YouTube", color: "#FF0000" },
];

export default function Contact() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="App" data-testid="contact-page">
      <SiteHeader />

      <div className="border-b border-black/10 bg-white">
        <div className="mx-auto max-w-7xl px-6 py-12 lg:px-10">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[var(--brand-primary)]">
            Contact Us
          </p>
          <h1 className="mt-3 font-display text-4xl font-extrabold tracking-tight sm:text-5xl">
            Let's talk.
          </h1>
          <p className="mt-3 max-w-xl text-lg text-[var(--text-secondary)]">
            Questions about a job, a bulk order or a custom request? Reach us any of the
            ways below — we're happy to help.
          </p>
        </div>
      </div>

      <div className="mx-auto grid max-w-7xl gap-8 px-6 py-14 lg:grid-cols-2 lg:px-10">
        {/* Direct contact */}
        <div className="space-y-4">
          <a
            href={`mailto:${CONTACT.email}`}
            data-testid="contact-email"
            className="group flex items-center gap-4 border border-black/10 bg-white p-6 transition-all hover:-translate-y-0.5 hover:border-[var(--brand-primary)] hover:shadow-md"
          >
            <span className="flex h-12 w-12 shrink-0 items-center justify-center bg-[var(--brand-primary)]/10 text-[var(--brand-primary)] transition-colors group-hover:bg-[var(--brand-primary)] group-hover:text-white">
              <Mail size={22} />
            </span>
            <span>
              <span className="block text-xs font-semibold uppercase tracking-wide text-[var(--text-secondary)]">
                Email us
              </span>
              <span className="block font-display text-lg font-bold">{CONTACT.email}</span>
            </span>
          </a>

          <a
            href={`tel:${CONTACT.phone}`}
            data-testid="contact-phone"
            className="group flex items-center gap-4 border border-black/10 bg-white p-6 transition-all hover:-translate-y-0.5 hover:border-[var(--brand-primary)] hover:shadow-md"
          >
            <span className="flex h-12 w-12 shrink-0 items-center justify-center bg-[var(--brand-primary)]/10 text-[var(--brand-primary)] transition-colors group-hover:bg-[var(--brand-primary)] group-hover:text-white">
              <Phone size={22} />
            </span>
            <span>
              <span className="block text-xs font-semibold uppercase tracking-wide text-[var(--text-secondary)]">
                Call us
              </span>
              <span className="block font-display text-lg font-bold">{CONTACT.phoneDisplay}</span>
            </span>
          </a>

          <div className="flex items-center gap-4 border border-black/10 bg-white p-6">
            <span className="flex h-12 w-12 shrink-0 items-center justify-center bg-[var(--brand-primary)]/10 text-[var(--brand-primary)]">
              <MapPin size={22} />
            </span>
            <span>
              <span className="block text-xs font-semibold uppercase tracking-wide text-[var(--text-secondary)]">
                Find us
              </span>
              <span className="block font-display text-lg font-bold">Victoria Road</span>
            </span>
          </div>

          <div className="flex items-center gap-4 border border-black/10 bg-white p-6">
            <span className="flex h-12 w-12 shrink-0 items-center justify-center bg-[var(--brand-primary)]/10 text-[var(--brand-primary)]">
              <Clock size={22} />
            </span>
            <span>
              <span className="block text-xs font-semibold uppercase tracking-wide text-[var(--text-secondary)]">
                Opening hours
              </span>
              <span className="block font-display text-lg font-bold">Mon–Sat · 9:00am – 5:00pm</span>
            </span>
          </div>
        </div>

        {/* Socials */}
        <div className="border border-black/10 bg-white p-6 sm:p-8">
          <h2 className="font-display text-2xl font-bold">Follow & message us</h2>
          <p className="mt-1 text-sm text-[var(--text-secondary)]">
            Tap WhatsApp to start a chat, or find us across social media.
          </p>

          <div className="mt-6 grid gap-3 sm:grid-cols-2">
            {socialMeta.map((s) => {
              const href = SOCIALS[s.key];
              const enabled = !!href;
              return (
                <motion.a
                  key={s.key}
                  href={enabled ? href : undefined}
                  target={enabled ? "_blank" : undefined}
                  rel="noopener noreferrer"
                  data-testid={`social-${s.key}`}
                  whileHover={enabled ? { y: -2 } : {}}
                  onClick={(e) => !enabled && e.preventDefault()}
                  aria-disabled={!enabled}
                  className={`flex items-center gap-3 border p-4 transition-colors ${
                    enabled
                      ? "cursor-pointer border-black/10 hover:border-[var(--brand-primary)] hover:bg-[var(--brand-primary)]/5"
                      : "cursor-not-allowed border-dashed border-black/10 opacity-50"
                  }`}
                >
                  <span className="shrink-0" style={{ color: s.color }}>
                    {brandIcons[s.key]}
                  </span>
                  <span className="flex flex-col">
                    <span className="font-semibold">{s.label}</span>
                    {!enabled && (
                      <span className="text-xs text-[var(--text-secondary)]">Coming soon</span>
                    )}
                  </span>
                </motion.a>
              );
            })}
          </div>
        </div>
      </div>

      {/* Google review CTA */}
      <div className="mx-auto max-w-7xl px-6 pb-16 lg:px-10">
        <div className="relative overflow-hidden border border-black/10 bg-[var(--brand-ink)] p-8 text-center sm:p-12">
          <div className="grain absolute inset-0" />
          <div className="relative">
            <div className="flex justify-center gap-1">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={22} className="fill-yellow-400 text-yellow-400" />
              ))}
            </div>
            <h2 className="mt-5 font-display text-3xl font-extrabold text-white sm:text-4xl">
              Enjoyed our service?
            </h2>
            <p className="mx-auto mt-3 max-w-lg text-white/70">
              A quick Google review means the world to a small business — it helps other
              locals find us. Thank you!
            </p>
            <a
              href={REVIEW_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="google-review-button"
              className="mt-7 inline-flex items-center gap-2 bg-white px-7 py-4 text-base font-bold text-[var(--brand-ink)] transition-transform hover:-translate-y-0.5"
            >
              <Star size={18} className="fill-yellow-400 text-yellow-400" /> Leave us a Google review
            </a>
          </div>
        </div>
      </div>

      <SiteFooter />
    </div>
  );
}
